var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.767,
    height: 14,
    viewBox: "0 0 11.767 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.012.89a7.859,7.859,0,0,0,3.279,11.524A6.123,6.123,0,1,1,8.012.89M8.436,0A7,7,0,1,0,13.2,12.116,6.992,6.992,0,0,1,9.794.134,7.047,7.047,0,0,0,8.436,0Z",
    transform: "translate(-1.436)",
    fill: "#afafaf"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moon.4fb752e9d7b1f235f3b698372465caa7.svg";